module.exports = __webpack_public_path__ + "static/media/葷麻辣大腸臭豆腐.f9409c87.jpg";